export default __webpack_public_path__ + "static/media/why-motion-banner.88d58a89.png";